import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=9ac71c70"
import script from "./FormContact.vue?vue&type=script&lang=js"
export * from "./FormContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports